import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

const GlobalStyle = createGlobalStyle`
${normalize}
html,body {
  padding: 0;
  margin: 0;
  background: #fff;
  font-family: Roboto-Regular,Helvetica,Arial,sans-serif;
}
button, input, video {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
}

@font-face {
  font-family: Roboto-Bold;
  src: url("https://static.kreditpintar.com/k8s-kp-website/fonts/Roboto-Bold.ttf?display=optional");
  font-display: swap;
}
@font-face {
  font-family: Roboto-Medium;
  src: url("https://static.kreditpintar.com/k8s-kp-website/fonts/Roboto-Medium.ttf?display=optional");
  font-display: swap;
}
@font-face {
  font-family: Roboto-Regular;
  src: url("https://static.kreditpintar.com/k8s-kp-website/fonts/Roboto-Regular.ttf?display=optional");
  font-display: swap;
}

a {
  color: inherit;
  text-decoration: none;
}

* {
  box-sizing: border-box;
}

#nprogress .bar { 
  background: #1cc812 !important;
} 
`

export default GlobalStyle
